var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-blue-dark tooltip--popup absolute mb-1/2" },
    [
      _c("p", { staticClass: "text-white p-1/4 m-0" }, [
        _vm._v(_vm._s(_vm.content)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }